import ContactUsInt, { Data } from 'ui/customer-support/components/contact-us-int';

type Props = {
  data: Data;
};

const ContactUsIntTastic = ({ data }: Props) => {
  return <ContactUsInt data={data} />;
};

export default ContactUsIntTastic;
